import { Reveal } from "./Reveal";
import { Search, PenLine, LineChart, RefreshCw } from "lucide-react";

const steps = [
  { icon: Search, no: "01", title: "Discover", desc: "We listen first — understanding your goals, obligations, values and time horizon in depth." },
  { icon: PenLine, no: "02", title: "Design", desc: "We build a personalized plan across investments, tax, retirement and estate — one coherent strategy." },
  { icon: LineChart, no: "03", title: "Deploy", desc: "We implement with institutional rigor and transparent, fee-only structures. No hidden agendas." },
  { icon: RefreshCw, no: "04", title: "Steward", desc: "We monitor, rebalance and adapt as your life and the markets evolve — proactively, not reactively." },
];

export const Approach = () => (
  <section id="approach" className="py-24 md:py-32" data-testid="approach-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid lg:grid-cols-12 gap-6 items-end mb-14">
        <Reveal className="lg:col-span-7">
          <p className="overline text-primary mb-4">Our Approach</p>
          <h2 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 leading-tight">
            A deliberate process, repeated with precision.
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="text-lg text-slate-600 leading-relaxed">
            Great outcomes are not accidental. Our four-part methodology brings structure and
            calm to every decision you make about your wealth.
          </p>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-px bg-border rounded-3xl overflow-hidden border border-border">
        {steps.map((s, i) => (
          <Reveal key={s.no} delay={i * 0.08}>
            <div className="group h-full bg-white p-8 hover:bg-[#f4f7fd] transition-colors duration-300">
              <div className="flex items-center justify-between">
                <div className="h-11 w-11 rounded-xl bg-accent flex items-center justify-center text-primary">
                  <s.icon size={20} />
                </div>
                <span className="font-mono text-sm text-slate-300 group-hover:text-primary transition-colors duration-300">{s.no}</span>
              </div>
              <h3 className="mt-6 font-serif text-2xl text-slate-900">{s.title}</h3>
              <p className="mt-3 text-slate-600 leading-relaxed text-[0.95rem]">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
